import { BooleanFormType } from "Store/interfaces/FormTypes";
import { CabinProductIntroFormValues } from "../Cabin/ProductIntro/cabinProductIntroInterfaces";

export enum AdditionalFMSBuildingType {
  GARAGE_ISOLATED = "GARAGE_ISOLATED",
  GARAGE_NON_ISOLATED = "GARAGE_NON_ISOLATED",
  CARPORT = "CARPORT",
  OUTHOUSE_ISOLATED = "OUTHOUSE_ISOLATED",
  OUTHOUSE_NON_ISOLATED = "OUTHOUSE_NON_ISOLATED",
  ANNEX_ISOLATED = "ANNEX_ISOLATED",
  ANNEX_NON_ISOLATED = "ANNEX_NON_ISOLATED",
  GARAGE_OUTHOUSE_ANNEX = "GARAGE_OUTHOUSE_ANNEX",
}

export enum AdditionalBuildingType {
  GARAGE = "GARAGE",
  CARPORT = "CARPORT",
  OUTHOUSE = "OUTHOUSE",
  ANNEX = "ANNEX",
  GARAGE_OUTHOUSE_ANNEX = "GARAGE_OUTHOUSE_ANNEX",
}

export enum AdditionalBuildingStandard {
  NORMAL = "NORMAL",
  HIGH = "HIGH",
}

export enum AdditionalBuildingArealLimit {
  LOWER = 1,
  UPPER = 200,
}

export enum AnnexArealLimit {
  LOWER = 1,
  UPPER = 100,
}

export interface AdditionalBuilding {
  type: string;
  areal: string;
  constructionYear: string;
  isolated?: boolean;
  id?: string;
  boa?: string;
  hasTapWater?: boolean;
  hasElectricity?: boolean;
  standard?: AdditionalBuildingStandard;
}

export interface AdditionalBuildingCommerce {
  readonly buildingIndex: number;
  readonly constructionYear: number;
  readonly coverage: string;
  readonly firstRiskSum?: number;
  readonly grossArea: number;
  readonly hasElectricity: boolean;
  readonly hasTapWater: boolean;
  readonly insuranceEvaluationType?: InsuranceEvaluationType;
  readonly isIsolated: boolean;
  readonly livingFloorSpace: number;
  readonly standard: AdditionalBuildingStandard;
  readonly type: F2100AdditionalBuildingType;
}

export interface AdditionalBuildingFormValues {
  additionalBuilding_buildingType?: string;
  additionalBuilding_areal?: string;
  additionalBuilding_constructionYear?: string;
  additionalBuilding_isolated?: boolean;
  additionalBuilding_boa?: string;
  additionalBuilding_hasTapWater?: BooleanFormType;
  additionalBuilding_hasElectricity?: BooleanFormType;
  additionalBuilding_standard?: AdditionalBuildingStandard;
}

export type AdditionalBuildingFormTypes = CabinProductIntroFormValues;

export enum F2100AdditionalBuildingType {
  ANNEX = "ANNEX",
  BOATHOUSE = "BOATHOUSE",
  CARPORT = "CARPORT",
  CHAINED_BOATHOUSE = "CHAINED_BOATHOUSE",
  CLOSED_OPERATING_BUILDING = "CLOSED_OPERATING_BUILDING",
  GARAGE = "GARAGE",
  GARAGE_INSULATED = "GARAGE_INSULATED",
  GARAGE_OUTHOUSE_ANNEX = "GARAGE_OUTHOUSE_ANNEX",
  GARAGE_UNINSULATED = "GARAGE_UNINSULATED",
  OUTHOUSE = "OUTHOUSE",
  OUTHOUSE_INSULATED = "OUTHOUSE_INSULATED",
  OUTHOUSE_UNINSULATED = "OUTHOUSE_UNINSULATED",
  WOODEN_FLOATING_DOCK = "WOODEN_FLOATING_DOCK",
}

export enum InsuranceEvaluationType {
  FIRST_RISK = "FIRST_RISK",
  FULL_VALUE = "FULL_VALUE",
}
